angular.module('impactx.tender').controller('TenderDetailCtrl', TenderDetailCtrl);
TenderDetailCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    '$config',
    'AppConfiguration',
    'ToastService',
    'TranslationService',
    'ToolbarService',
    'AttachmentUploadService'
];

function TenderDetailCtrl($scope, dataGen, $routeParams, BackService, $mdToast, ConfirmationService, $config, AppConfiguration, ToastService, TranslationService, ToolbarService, AttachmentUploadService) {
    var ctrl = this;
    $scope.searchTextProcurementGroup = {};
    $scope.searchTextProcurementGroup.value = "";
    $scope.showInactiveRfqc = false;

    ctrl.tenderUploadConfig = function () {
        return { url: '/tender/attachment/add', idParam: 'tenderId', id: $scope.data.id };
    }

    ctrl.save = function () {
        removeEmptyClassifications();
        let pending = AttachmentUploadService.extractPendingUploads($scope.data.attachments);

        var dataObj = {
            tender: $scope.data
        };

        if (!dataObj.tender.selectedProcurementGroup && $scope.searchTextProcurementGroup.value.length > 0) {
            dataObj.tender.selectedProcurementGroup = $scope.searchTextProcurementGroup.value;
        }
        return dataGen.postAsForm({}, dataObj, "/tender/save")
            .then(function (savedData) {
                if (savedData.data.id) {
                    $scope.data.id = savedData.data.id;
                }
                return AttachmentUploadService.uploadPendingAttachments(ctrl.tenderUploadConfig(), pending);
            })
            .then(function () {
                BackService.back();
                $mdToast.show($mdToast.simple().textContent($scope.trns.saveSuccess).position("bottom right").hideDelay(10000));
            })
            .catch(function () {
                AttachmentUploadService.restorePendingUploads($scope.data.attachments, pending);
            });
    };

    ctrl.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(ctrl.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    ctrl.delete = function () {
        var dataObj = {
            id: $scope.data.id
        };
        dataGen.postAsForm($scope, dataObj, "/tender/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    ctrl.getItemText = function (entry) {
        if (entry) {
            return entry;
        }
        else {
            $scope.searchTextProcurementGroup = undefined;
            return '';
        }
    };

    dataGen.getData($scope, {id: $routeParams.id}, "/tender/viewdetail").then(function () {
        defineButtons();
    });

    function removeEmptyClassifications() {
        for (var i = $scope.data.classifications.assigned.length - 1; i >= 0; i--) {
            var assigned = $scope.data.classifications.assigned[i];
            if ((assigned.selected && assigned.selected.id <= 0) || assigned.freeSelection && !assigned.freeSelection.value) {
                $scope.data.classifications.assigned.splice(i, 1);
            }
        }
    }

    $scope.tinymceOptions = $config.tinymceOptions;
    $scope.isClassificationRequired = AppConfiguration.get('requiredClassificationForTenderAndLot');

    ctrl.addAdditionalCPV = function () {
        if (!impactX.isDefined($scope, 'data.additionalCPVs')) {
            $scope.data.additionalCPVs = [];
        }
        $scope.data.additionalCPVs.push({});
    };

    ctrl.removeAdditionalCPV = function (cpv) {
        var index = $scope.data.additionalCPVs.indexOf(cpv);
        if (index >= 0) {
            $scope.data.additionalCPVs.splice(index, 1);
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
        }
    };

    ctrl.updateMainProcurementGroup = function (selectedSPG) {
        if (impactX.isDefined($scope.data, 'mpgPopup') && impactX.isDefined(selectedSPG, 'id') &&
            (!$scope.data.mpgPopup.selected || !$scope.data.mpgPopup.selected.id)) {
            if (!selectedSPG.parent || !selectedSPG.parent.id || selectedSPG.parent.id === 0) {
                $scope.data.mpgPopup.selected = undefined;
            }
            else {
                $scope.data.mpgPopup.selected = selectedSPG.parent;
            }
        }
    };

    ctrl.updateSecondProcurementGroups = function (selectedMPG) {
        if (impactX.isDefined($scope.data, 'spgPopup')
            && selectedMPG && selectedMPG.id && selectedMPG.id > 0
            && $scope.data.spgPopup.selected && $scope.data.spgPopup.selected.id && $scope.data.spgPopup.selected.id > 0
            && (!$scope.data.spgPopup.selected.parent || !$scope.data.spgPopup.selected.parent.id || $scope.data.spgPopup.selected.parent.id !== selectedMPG.id)) {
                $scope.data.spgPopup.selected = undefined;
        }
    };

    ctrl.canDeleteHashes = function () {
        return $scope.data && $scope.data.id && $scope.data.canDeleteHashes;
    };

    ctrl.deleteHashes = function () {
        var id = $scope.data.id;
        if (id) {
            return dataGen.postAsForm({}, {tenderId: id}, "/tender/deletehashes").then(function () {
                ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            });
        }
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: ctrl.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.delete,
                action: ctrl.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            },
            {
                label: $scope.trns.deleteHashes,
                action: ctrl.deleteHashes,
                type: 'dialogaction',
                condition: ctrl.canDeleteHashes
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canDelete() {
        return isEditable() && !$scope.data.mainPartReadOnly && $scope.data.id > 0
    }

    ctrl.tttPopupChanged = function (selectedTTT) {
        if (selectedTTT && selectedTTT.secondValue === "100000012") {
            $scope.data.useBaseTenderForOGD.value = true;
        }
    };
}
